import Questionnaires from '@/pages/Questionnaries';
import { ROUTES } from './routes.config';

export const QuestionnairesRoutes = {
    path: ROUTES.QUESTIONNAIRES,
    element: <Questionnaires />,
};
